// extracted by mini-css-extract-plugin
module.exports = {"container":"settings-tab_container__2up82","header":"settings-tab_header__2BreI","active":"settings-tab_active__1yaQh"};